import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  output,
  signal,
  untracked,
} from '@angular/core';
import { Router } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideTriangleAlert } from '@ng-icons/lucide';
import { HlmAlertImports } from '@spartan-ng/helm/alert';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmDialogImports } from '@spartan-ng/helm/dialog';
import { HlmSpinnerImports } from '@spartan-ng/helm/spinner';
import { HlmTypographyImports } from '@spartan-ng/helm/typography';
import { TemplatePickerComponent } from '../../../../components/settings/voucher-design-settings/components/new-design-dialog/template-picker/template-picker.component';
import { LoggerService } from '../../../../services/logger.service';
import { DesignTemplate, VoucherDesignService } from '../../../../services/voucher-design.service';

/** Pick one of the bundled artworks as the background of the design being edited. */
@Component({
  selector: 'app-background-template-dialog',
  standalone: true,
  imports: [
    NgIcon,
    HlmAlertImports,
    HlmButtonImports,
    HlmDialogImports,
    HlmSpinnerImports,
    HlmTypographyImports,
    TemplatePickerComponent,
  ],
  providers: [provideIcons({ lucideTriangleAlert })],
  templateUrl: './background-template-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackgroundTemplateDialogComponent {
  private readonly designService = inject(VoucherDesignService);
  private readonly logger = inject(LoggerService);

  readonly open = input(false);
  readonly busy = input(false);
  readonly choose = output<string>();
  readonly close = output<void>();
  private readonly router = inject(Router);

  readonly templates = signal<DesignTemplate[] | null>(null);
  readonly error = signal<string | null>(null);
  readonly selectedKey = signal<string | null>(null);

  /** To the logo and banner uploads on the "Marke & Branding" tab; the dialog closes. */
  goToBranding() {
    this.close.emit();
    void this.router.navigate(['/settings'], {
      queryParams: { tab: 'brand' },
      fragment: 'section-logo',
    });
  }

  constructor() {
    effect(() => {
      if (!this.open()) return;
      untracked(() => {
        this.selectedKey.set(null);
        this.load();
      });
    });
  }

  load() {
    this.error.set(null);
    this.designService.templates().subscribe({
      next: ({ templates }) => this.templates.set(templates),
      error: (error) => {
        this.logger.error('Vorlagen konnten nicht geladen werden:', error);
        this.error.set('Die Vorlagen konnten nicht geladen werden.');
      },
    });
  }

  onDialogState(state: 'open' | 'closed') {
    if (state === 'closed' && this.open()) this.close.emit();
  }
}
